<template>
  <div
    class="card-main"
    @click="onClick"
    @mouseover="focusOn"
    @mouseleave="focusOut"
  >
    <div class="focus-ring" v-show="isfocusOn && mouseActivated"></div>
    <img v-if="cardData.imgUrl" class="cover-img" v-lazy="cardData.imgUrl" />
    <img v-else class="cover-img" v-lazy="cardData.poster" />
    <!-- <img v-if="cardData.imgUrl" class="cover-img" :src="cardData.imgUrl" /> -->
    <!-- <img v-else class="cover-img" :src="cardData.poster" /> -->
    <div class="card-text">
      <div class="title-area">
        <p class="title doubleline">{{ cardData.title }}</p>
      </div>
      <!-- 20210625 [refs #13000] 건으로 제거   -->
      <!-- <p class="league singleline">{{ cardData.leagueName }}</p> -->
    </div>
  </div>
</template>

<script>
import { contentsPermissionCheck } from "@/utils/common"

export default {
  data() {
    return {
      isActiveVue: true,
      isfocusOn: false,
    };
  },

  props: ["cardData", "isFocusedLine"],

  computed: {
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
  },

  methods: {
    onClick() {
      if (this.isfocusOn) {
        this.clickCard();
      }
    },
    async clickCard() {
      if (["vod", "live"].includes(this.cardData.type)) {
        const checkParams = {
          type: this.cardData.type,
          id: this.cardData.id
        }

        // 리그 전용 이용권 시청 권한 확인
        const checkValue = await contentsPermissionCheck(checkParams)

        if (checkValue) {
          this.focusOut();
          this.$router.push({
            name: "player",
            params: {
              vodId: this.cardData.videoId || this.cardData.id,
              contentType: this.cardData.type,
            },
          });
        }
      } else {
        this.$router.push({
          name: "game-detail",
          params: {
            gameId: this.cardData.id,
            t: new Date().getTime(),
          },
        });
      }
      this.focusOut();
    },
    focusOn() {
      if (this.isFocusedLine) {
        this.isfocusOn = true;
      }
    },
    focusOut() {
      this.isfocusOn = false;
    },
  },
};
</script>

<style scoped>
.card-main {
  position: relative;
  display: inline-block;
  margin-right: 24px;
  height: 324px;
}
.focus-ring {
  position: absolute;
  left: -5px;
  top: -4px;
  width: 366px;
  height: 324px;
  border: solid 4px #eeeeee;
  z-index: 5;
}
.cover-img {
  width: 366px;
  height: 206px;
  background-color: #2b2b2b;
}
.card-text {
  height: 110px;
  width: 346px;
  padding: 0 10px;
  display: inline-block;
  position: absolute;
  top: 214px;
  left: 0;
}
.title-area {
  height: 64px;
}
.title {
  font-size: 24px;
  line-height: 32px;
  overflow: hidden;
  color: #a0a0a0;
}
.league {
  font-size: 18px;
  margin-top:8px;
  line-height: 1;
  color: #707070;
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .card-main {
    position: relative;
    display: inline-block;
    margin-right: 24px;
    height: 227px;
  }
  .focus-ring {
    position: absolute;
    left: -3px;
    top: -3px;
    width: 250px;
    height: 233px;
    border: solid 3px #ffffff;
    z-index: 5;
  }
  .cover-img {
    width: 244px;
    height: 137px;
    background-color: #2b2b2b;
  }
  .card-text {
    height: 90px;
    width: 100%;
    padding: 12px 4px;
    display: inline-block;
    position: absolute;
    top: 137px;
    left: 0;
  }
  .title-area {
    height: 48px;
  }
  .title {
    font-size: 16px;
    line-height: 24px;
    overflow: hidden;
    color: #a0a0a0;
  }
}
</style>